/**
 * Shape表示用のヒント視点
 * PartSelectで「形状がおかしい視点のヒント」を表示するときの視点
 */
export const showHintPositions = {
  model1: { x: -492, y: 79, z: 0 },     // 横から
  model2: { x: 0, y: 500, z: -1 },      // 上から
  model3: { x: 0, y: 500, z: -1 },     // 真上から（幅だけ太くしたグラスの飲み口がつぶれて見える）
  model4: { x: -492, y: 148, z: 30 },
  model5: { x: 0, y: -500, z: -1 },   // 真下から（テーパーが無く、底が皿と重なって見える）
  model6: { x: 0, y: 500, z: -1 },     // 真上から（広すぎるふちがグラスと重なって見える）
  model7: { x: -492, y: 79, z: 0 },
  model8: { x: -492, y: 20, z: 0 },   // 横から（深くした皿の底がグラスの底より下に沈みこんで見える）
  cube_model1: { x: 30, y: 700, z: 0 },     // 上から
  cube_model2: { x: -492, y: 79, z: -174 },    // 横から
  cube_model3: { x: 100, y: 900, z: 0 },    // 上から
  cube_model4: { x: 100, y: 79, z: 300 },   // 背面から
  cube_model5: { x: -497, y: 79, z: 0 },     // 横から
};

export const showHintTargets = {
  model1: { x: 0, y: 0, z: 0 },
  model2: { x: 0, y: 0, z: 0 },
  model3: { x: 0, y: 0, z: 0 },
  model4: { x: 0, y: 0, z: 0 },
  model5: { x: 0, y: 0, z: 0 },
  model6: { x: 0, y: 0, z: 0 },
  model7: { x: 0, y: 0, z: 0 },
  model8: { x: 0, y: 0, z: 0 },
  cube_model1: { x: 0, y: 0, z: 0 },
  cube_model2: { x: 0, y: 0, z: 0 },
  cube_model3: { x: 0, y: 0, z: 0 },
  cube_model4: { x: 0, y: 0, z: 0 },
  cube_model5: { x: 0, y: 0, z: 0 },
};

// showHintPositions が実際どちら向きの視点かをテキストで補足する（GazeControlの「顕在化された視点」列で使用）。
// 3Dモデル上部の視点だけでは横から/上からの区別が学習者に伝わりにくいための説明文。
export const showHintDescriptions = {
  model1: '横から見た視点',
  model2: '真上から見た視点',
  model3: '真上から見た視点',
  model4: '横から見た視点（やや上）',
  model5: '真下から見た視点',
  model6: '真上から見た視点',
  model7: '横から見た視点',
  model8: '横から見た視点',
  cube_model1: '真上から見た視点',
  cube_model2: '横から見た視点',
  cube_model3: '真上から見た視点',
  cube_model4: '背面から見た視点',
  cube_model5: '横から見た視点',
};

/**
 * 基本となる視点（Gaze Controlの右モデルで使用）
 */
export const defaultCameraPosition = { x: 0, y: 194, z: -461 };
export const defaultCameraTarget = { x: 0, y: 0, z: 0 };
